// Generated from SVG to Code Figma Plugin

import type { JSX } from 'react';

export const ChevronDown2 = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M1.64648 5.00008L8.00004 11.3536L14.3536 5.00008L13.6465 4.29297L8.00004 9.93942L2.35359 4.29297L1.64648 5.00008Z"
      fill="currentColor"
    />
  </svg>
);
